import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '@app/components/atoms/button/button.module';
import { AssessmentSelfManagementInformationComponent } from './assessment-self-management-information.component';

@NgModule({
  declarations: [
    AssessmentSelfManagementInformationComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
  ],
  exports: [
    AssessmentSelfManagementInformationComponent
  ]
})
export class AssessmentSelfManagementInformationModule { }
